import { CRUDMode } from '/src/lib/types';
import { theme } from '/src/theme';

/**
 * Format numbers as currency
 */
export const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/**
 * Format numbers as decimals
 */
export const decimal = new Intl.NumberFormat('en-US', { style: 'decimal' });

/**
 * Format numbers as percents
 */
export const percent = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Converts a string to JSON, returning `undefined` instead of throwing an error if string is not valid JSON.
 * @param {string} input
 * @returns JSON object
 */
export const toJSON = (input?: string) => {
  if (!input) return;
  try {
    return JSON.parse(input);
  } catch (_) {
    return;
  }
};

/**
 * Get props for use with FuseSpeedDial components.
 *
 * @param actionType CRUD action to perform.
 * @param label Button label.
 * @param tooltip Button tooltip.
 * @returns Component props object
 */
export const getSpeedDialActionProps = (actionType: CRUDMode, label: string, tooltip?: string) => {
  switch (actionType) {
    case CRUDMode.Edit:
      return {
        fab: {
          'aria-label': label,
          className: 'md-fab md-mini md-accent md-button md-default-theme',
        },
        tooltip: {
          title: tooltip || label,
        },
      };
    case CRUDMode.Remove:
      return {
        fab: {
          'aria-label': label,
          className: 'md-fab md-mini md-warn md-button md-default-theme',
          style: { background: theme.palette.warning.main, color: 'white' },
        },
        tooltip: {
          title: tooltip || label,
        },
      };
    default:
      return {};
  }
};
